import React from 'react';
import { View } from 'react-native';

import { useFinancialSummary } from '@/hooks/use-financial-summary';
import { useRecentCharges } from '@/hooks/use-recent-charges';
import { CHARGE_STATUS } from '@/types/charge-status';
import { formatCurrency } from '@/utils/format-currency';
import { formatDate } from '@/utils/format-date';
import { SummaryEmpty, SummaryRow, SummarySkeleton, SummaryStat } from '../home-summary-dialog';

const OPEN_STATUSES = [
  CHARGE_STATUS.PENDING,
  CHARGE_STATUS.OVERDUE,
  CHARGE_STATUS.PAYMENT_REPORTED,
];

/** Prévia de "A receber": pendente, atrasado e as próximas cobranças em aberto. */
export function ReceivablesSummary() {
  const { data: financial } = useFinancialSummary();
  const { data: charges, isLoading } = useRecentCharges(20);

  const open = (charges ?? [])
    .filter((charge) => OPEN_STATUSES.includes(charge.status))
    .sort((a, b) => new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime());

  const overdueTotal = open
    .filter((charge) => charge.status === CHARGE_STATUS.OVERDUE)
    .reduce((sum, charge) => sum + Number(charge.amount), 0);

  return (
    <View className="gap-3">
      <View className="flex-row gap-2">
        <SummaryStat label="A receber" value={formatCurrency(financial?.balance.pending ?? 0)} />
        <SummaryStat label="Em atraso" value={formatCurrency(overdueTotal)} tone="negative" />
      </View>

      {isLoading ? (
        <SummarySkeleton rows={3} />
      ) : open.length ? (
        <View className="gap-2">
          {open.slice(0, 4).map((charge) => {
            const overdue = charge.status === CHARGE_STATUS.OVERDUE;
            return (
              <SummaryRow
                key={charge.id}
                icon={overdue ? 'alert-circle-outline' : 'time-outline'}
                title={charge.clientName ?? charge.enrollment?.client?.user?.username ?? 'Cliente'}
                description={`${overdue ? 'Venceu' : 'Vence'} em ${formatDate(charge.dueDate)}`}
                value={formatCurrency(charge.amount)}
                valueTone={overdue ? 'negative' : 'default'}
              />
            );
          })}
        </View>
      ) : (
        <SummaryEmpty message="Nenhuma cobrança em aberto." />
      )}
    </View>
  );
}
